import React from 'react';
import { DivContent } from './styles';

export interface Props {
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLElement>;
}

const Content = ({ children, onClick }: Props): JSX.Element => {
  return (
    <DivContent className="mcv3-card" onClick={onClick}>
      {children}
    </DivContent>
  );
};

export default Content;
